(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('accordion-custom details');

  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', function () {
      if (accordion.open) {
        // Close other accordions
        accordions.forEach((otherAccordion) => {
          if (otherAccordion !== accordion) {
            otherAccordion.removeAttribute('open');
            otherAccordion.classList.remove('active');
          }
        });
        // Add active class to currently opened accordion
        accordion.classList.add('active');
      } else {
        accordion.classList.remove('active');
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
